import { Outlet } from "react-router-dom";
import Banner from "./components/Banner";
// import logo from "@assets/mbs-logo.svg";
import { useTheme } from "@/src/context/themeContext";
import { useEffect } from "react";
const Auth = () => {
  const { setTheme } = useTheme();

  useEffect(() => {
    if (!window.location.href.includes("app")) {
      setTheme("light");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);
  return (
    <div className=" min-h-screen w-screen overflow-x-hidden flex items-center  bg-auth-bg bg-cover bg-no-repeat relative ">
      <Banner />
      {/* <div className="flex items-center justify-center px-4 mt-10 w-full "> */}
      <div className=" border border-gray-200 md:mx-auto md:w-[500px] w-full bg-white rounded-3xl p-4 md:p-8 mx-5 mt-5">
        {/* <img src={logo} className="h-8 mx-auto " /> */}
        <Outlet />
      </div>
      {/* </div> */}
    </div>
  );
};

export default Auth;
